/**
 * Daily log approval layout switch (W-iP5).
 *
 * Below this width (iPad landscape 1180 and portrait 820, and phones) the Work Completed table
 * becomes one card per entry and the Approve / Send for Revisions / Decline bar stays pinned.
 * Desktop widths (1366 / 1536 / 1920) keep the table. Width-based, never user-agent based.
 */
export const DAILY_LOG_CARD_LAYOUT_QUERY = '(max-width: 1279.98px)';
